﻿export interface ISingleEpletMmRisk {
    recipientId: number;
    donorId: number;
    singleEpletMmDr: number;
    singleEpletMmDq: number;
    singleEpletMmDqLow: number;
    totalEpletMmDr: number;
    totalEpletMmDq: number;
    singleEpletRisk: number;
    singleEpletRiskLow: number;
    totalEpletRisk: number;
    overallRisk: number;
    isAboCompatible: boolean;
    isCompatiblePair: boolean;
    sortValue: number;
    expectedWaitTimeLowEmm: number;
    label: string;
}
